import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { ApiExError } from '@shared';

const openAiCompletionSearchSlice = createSlice({
  name: 'openAiCompletionSearch',
  initialState: initialState.openAiCompletionSearch,
  reducers: {
    // API triggers (for saga/middleware)
    postOpenAiCompletionSearchRequest: (
      _state,
      _action: PayloadAction<OpenAiCompletionSearchRequest>,
    ) => {},
    postOpenAiCompletionSearchResponse(
      state,
      action: PayloadAction<OpenAiCompletionDbRecord>,
    ) {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    postOpenAiCompletionSearchFailure: (state, action: PayloadAction<ApiExError>) => {
      state.data = null;
      state.isLoading = false;
      state.error = action.payload;
    },

    // Local state management
    setSearchLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    resetOpenAiCompletionSearchState: state => {
      state.data = null;
      state.error = null;
      state.isLoading = false;
    },
  },
});

export const {
  postOpenAiCompletionSearchRequest,
  postOpenAiCompletionSearchResponse,
  postOpenAiCompletionSearchFailure,
  setSearchLoading,
  resetOpenAiCompletionSearchState,
} = openAiCompletionSearchSlice.actions;

export const openAiCompletionSearchSliceReducer = openAiCompletionSearchSlice.reducer;